import React from 'react';
import Sidebar from './Sidebar';
import { useSidebar } from '../context/SidebarContext';

const MainLayout = ({ children }) => {
  const { isCollapsed } = useSidebar();
  
  return (
    <div className="flex min-h-screen bg-bg-gray dark:bg-dark-bg">
      <Sidebar />
      <main className={`flex-1 transition-all duration-300 ${isCollapsed ? 'ml-16' : 'ml-64'}`}>
        <div className="p-8">
          {children}
        </div>
      </main>
    </div>
  );
};

export default MainLayout;
